import React from 'react';

const ErrorMessage = ({ message, onDismiss = null }) => {
  if (!message) return null;

  return (
    <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 flex items-start gap-3">
      <span className="material-symbols-outlined text-red-500 text-xl">error</span>
      <div className="flex-1">
        <p className="text-red-500 text-sm">{message}</p>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-red-500 hover:text-red-400 transition-colors"
        >
          <span className="material-symbols-outlined text-xl">close</span>
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
